




import { Vue, Component, Prop } from 'vue-property-decorator'
import { Empty } from 'vant'

const ImgEmpty = require('@assets/images/img-empty@3x.png')

@Component({
  components: {
    [Empty.name]: Empty,
  },
})
export default class EmptyComponent extends Vue {
  @Prop({ default: '粑粑麻麻，没有相关数据' }) readonly noData!: string

  ImgEmpty = ImgEmpty
  created() {
    this.$nextTick(() => {
      const empty: any = this.$refs.empty
      if (empty && empty.$el) {
        try {
          const emptyEle: HTMLElement = empty.$el
          const clientHeight = document.body.clientHeight
          const offsetTop = emptyEle.offsetTop
          const diff = clientHeight - offsetTop
          const min = diff - offsetTop - 20;
          if (min > 360) {
            emptyEle.style.height = `${min}px`;
          }
        } catch (error) {
          console.log(error)
        }
      }
    })
  }
}
